var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProgrammingArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M5.75 16.11V7.90001C7.04 7.57001 8 6.40001 8 5.01001C8 3.35001 6.66 2.01001 5 2.01001C3.34 2.01001 2 3.35001 2 5.01001C2 6.41001 2.96 7.57001 4.25 7.90001V16.11C2.96 16.44 2 17.61 2 19C2 20.66 3.34 22 5 22C6.66 22 8 20.66 8 19C8 17.6 7.04 16.44 5.75 16.11Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 16.1099V6.49993C19.75 4.97993 18.52 3.74993 17 3.74993H14.07L15.48 2.57993C15.8 2.30993 15.84 1.83993 15.58 1.51993C15.31 1.19993 14.84 1.15993 14.52 1.41993L11.52 3.91993C11.35 4.05993 11.25 4.26993 11.25 4.49993C11.25 4.72993 11.35 4.92993 11.52 5.07993L14.52 7.57993C14.66 7.69993 14.83 7.74993 15 7.74993C15.21 7.74993 15.43 7.65993 15.58 7.47993C15.85 7.15993 15.8 6.68993 15.48 6.41993L14.07 5.24993H17C17.69 5.24993 18.25 5.80993 18.25 6.49993V16.1099C16.96 16.4399 16 17.6099 16 18.9999C16 20.6599 17.34 21.9999 19 21.9999C20.66 21.9999 22 20.6599 22 18.9999C22 17.5999 21.04 16.4399 19.75 16.1099Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProgrammingArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/programming-arrow.e74666117b13fa8dc5339aeea485551c.svg";